import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { token } from "functions/Helper";
import CreateMerchantInventoryAdjustments from "views/MerchantInventoryAdjustment/CreateMerchantInventoryAdjustment";
import MerchantInventoryAdjustmentList from "views/MerchantInventoryAdjustment/MerchantInventoryAdjustmentList";
import ViewMerchantInventoryAdjustments from "views/MerchantInventoryAdjustment/ViewMerchantInventoryAdjustment";

const merchantInventoryAdjustments = () => {
  let views = [];

  if (
    token["travelagent.inventory_adjustment.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventoryAdjustments/List",
      name: "M Inventory Adjustments",
      icon: ConfirmationNumberIcon,
      component: MerchantInventoryAdjustmentList,
      layout: "/admin"
    });
  }

  if (views.length > 0) return views;
  return [];
};

const merchantInventoryAdjustmentsHidden = () => {
  let views = [];

  if (
    token["travelagent.inventory_adjustment.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventoryAdjustments/Detail",
      name: "View Merchant Inventory Adjustments",
      component: ViewMerchantInventoryAdjustments,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["travelagent.inventory_adjustment.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventoryAdjustments/Create",
      name: "Create Merchant Inventory Adjustments",
      component: CreateMerchantInventoryAdjustments,
      layout: "/admin"
    });
  }

  return [
    {
      collapse: true,
      name: "Merchant Inventory Adjustments Hidden",
      state: "merchantInventoryAdjustmentsHidden",
      hideInSidebar: true,
      views
    }
  ];
};

export { merchantInventoryAdjustments, merchantInventoryAdjustmentsHidden };
